import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, X } from 'lucide-react';
interface TermItem {
  title: string;
  body: string;
}
const TERMS: TermItem[] = [{
  title: '1. Aceptación de los términos',
  body: 'Al utilizar este sitio web o agendar servicios en El Rey Barba Barbería, el usuario acepta los presentes términos y condiciones en su totalidad.'
}, {
  title: '2. Servicios y precios',
  body: 'Los precios publicados están expresados en pesos colombianos (COP) y pueden variar sin previo aviso. Las membresías son personales e intransferibles, válidas únicamente para la persona que las adquiere, salvo en el caso de la Membresía Silver (Padre e Hijo).'
}, {
  title: '3. Vigencia de las membresías',
  body: 'Cada membresía tiene una vigencia de 60 días calendario a partir de la fecha de compra. Los servicios no utilizados dentro de este periodo no son reembolsables ni transferibles.'
}, {
  title: '4. Reservas y citas',
  body: 'Las citas se confirman vía WhatsApp al número 302 828 1216. Solicitamos llegar con 5 minutos de anticipación. Las cancelaciones deben realizarse con al menos 2 horas de antelación.'
}, {
  title: '5. Política de cancelación',
  body: 'La inasistencia a una cita reservada sin previo aviso podrá descontar un servicio de la membresía adquirida.'
}, {
  title: '6. Uso del sitio web',
  body: 'El contenido, imágenes, logotipo y diseño del sitio son propiedad de El Rey Barba Barbería. Queda prohibida su reproducción total o parcial sin autorización escrita.'
}, {
  title: '7. Protección de datos personales',
  body: 'La información proporcionada en el formulario de contacto se utiliza únicamente para gestionar la solicitud del cliente. No compartimos datos con terceros. Cumplimos con la Ley 1581 de 2012 de Colombia.'
}, {
  title: '8. Atención a menores',
  body: 'Los menores de edad deben asistir acompañados de un adulto responsable.'
}, {
  title: '9. Modificaciones',
  body: 'El Rey Barba Barbería se reserva el derecho de modificar estos términos en cualquier momento. Los cambios se publicarán en esta misma página.'
}, {
  title: '10. Contacto',
  body: 'Para cualquier consulta sobre estos términos, escríbenos al WhatsApp 302 828 1216 o al correo Barberilaelreybarba@gmail.com.'
}];
interface TerminosModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TerminosModal({
  isOpen,
  onClose
}: TerminosModalProps) {
  return <AnimatePresence data-id="element-328">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-329">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} onClick={e => e.stopPropagation()} className="relative bg-deepblack border-2 border-gold rounded-lg max-w-3xl w-full max-h-[85vh] overflow-hidden flex flex-col shadow-gold-glow-lg" data-id="element-330">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gold/30 bg-black/40" data-id="element-331">
              <div className="flex items-center gap-3" data-id="element-332">
                <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold flex items-center justify-center" data-id="element-333">
                  <ShieldCheck className="w-5 h-5 text-gold" data-id="element-334" />
                </div>
                <div data-id="element-335">
                  <h2 className="font-serif text-xl md:text-2xl text-bone font-bold leading-tight" data-id="element-336">
                    Términos y Condiciones
                  </h2>
                  <p className="text-gold text-xs uppercase tracking-wider" data-id="element-337">
                    Información Legal
                  </p>
                </div>
              </div>
              <button onClick={onClose} className="text-gold hover:text-white transition-colors p-2 hover:bg-gold/10 rounded-full" aria-label="Cerrar" data-id="element-338">
                <X className="w-5 h-5" data-id="element-339" />
              </button>
            </div>

            {/* Content - Scrollable */}
            <div className="overflow-y-auto p-6 space-y-5 flex-1" data-id="element-340">
              {TERMS.map((item, index) => <div key={index} className="border-l-4 border-gold pl-4 py-1" data-id="element-341">
                  <h3 className="font-serif text-base md:text-lg text-gold font-semibold mb-2" data-id="element-342">
                    {item.title}
                  </h3>
                  <p className="text-bone/80 text-sm leading-relaxed" data-id="element-343">
                    {item.body}
                  </p>
                </div>)}
              <p className="text-center text-bone/50 text-xs italic pt-4 border-t border-gold/20" data-id="element-344">
                Última actualización: Junio 2026 · Bogotá, Colombia
              </p>
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-gold/30 bg-black/40 flex justify-end" data-id="element-345">
              <button onClick={onClose} className="bg-gold text-deepblack px-6 py-2 rounded-full font-semibold hover:bg-yellow-500 transition-colors text-sm" data-id="element-346">
                Entendido
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}